"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAlgorandWalletState = exports.defaultWalletState = exports.WALLET_TYPES = void 0;
var WALLET_TYPES;
(function (WALLET_TYPES) {
    WALLET_TYPES[WALLET_TYPES["NONE"] = 0] = "NONE";
    WALLET_TYPES[WALLET_TYPES["META_MASK"] = 1] = "META_MASK";
    WALLET_TYPES[WALLET_TYPES["WALLET_CONNECT"] = 2] = "WALLET_CONNECT";
    WALLET_TYPES[WALLET_TYPES["ALGO_SIGNER"] = 3] = "ALGO_SIGNER";
})(WALLET_TYPES = exports.WALLET_TYPES || (exports.WALLET_TYPES = {}));
exports.defaultWalletState = {
    isConnected: false,
    isConnecting: false,
    currentWallet: WALLET_TYPES.NONE,
    walletAddress: "",
    currentWalletNetwork: 0,
    walletBalance: "",
    error: "",
    networkClient: undefined,
    isWeb3Initialized: false,
};
exports.defaultAlgorandWalletState = {
    isAlgoConnected: false,
    isAlgoConnecting: false,
    walletAddresses: [],
    connectedAlgorandWalletAddress: "",
    error: "",
    algorandNetworkClient: undefined,
    isAlgosignerInitialized: false,
    currentledger: undefined,
};
//# sourceMappingURL=walletConnectorInterfaces.js.map